export default __webpack_public_path__ + "f14b71b0f330c071aaeac56980f669bd.png";